import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import parse from "html-react-parser";
import size1 from "../../../../../assets/img/stencil_size1.png";
import size2 from "../../../../../assets/img/stencil_size2.png";
import "./StencilCustomizedSize.css";
import StensileQuotationFormData from "./StensileQuotationFormData";
import InitialQuotationState from "../../InitialQuotationState";
import closeBtnModel from "../../../../../assets/img/closeBtnModel.png";


var a = "notSelected";
var rex = /[\uFF10-\uFF19]/g;
class StencilCustomizedSize extends Component {
    constructor(props) {
        super(props);
        StensileQuotationFormData.conformButton = false;

        this.state = {
            show: this.props.show,

            isDisabled: true,
            x: 0,
            y: 0,
            error : null
        };
        this.conformCustomSize = this.conformCustomSize.bind();
        this.validateDimension = this.validateDimension.bind();
        this.validateDimensionX = this.validateDimensionX.bind();
        this.validateDimensionY = this.validateDimensionY.bind();
    }

    conformCustomSize = (event, val) => {
        this.setState({
           error : null
        });
        if (val === 1) {
            this.setState({
                isDisabled: true
            }, ()=> {
                document.getElementById("xValue").value = '';
                document.getElementById("yValue").value = '';
            });
            this.setState({
                x: 380,
                y: 280
            });
            a = "selected";
        }
        if (val === 2) {
            this.setState({
                isDisabled: false
            });
            a = "selected";
        }
        if (val === 3) {
            let val2 = event.target.value;

            val2 = val2.replace(rex, function(ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 65248);
            });
            val2 = val2.replace(/\s/g, '');
            val2 = val2.replace(/\u3002/g, ".");

            if (this.validateDimensionX(val2)) {
                this.setState({
                    x: val2
                },()=>{document.getElementById("xValue").value = this.state.x});
                a = "selected";
            } else {
                document.getElementById('xValue').value = "";
                this.setState({
                    x: 0,
                    error : "有効サイズより大きくできません。"
                });
            }
        }
        if (val === 4) {

            let val1 = event.target.value;

            val1 = val1.replace(rex, function(ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 65248);
            });
            val1 = val1.replace(/\s/g, '');
            val1 = val1.replace(/\u3002/g, ".");

            if (this.validateDimensionY(val1)) {
                this.setState({
                    y: val1
                },()=>{document.getElementById("yValue").value = this.state.y});
                a = "selected";
            } else {
                document.getElementById('yValue').value = "";
                this.setState({
                    y: 0,
                    error : "有効サイズより大きくできません。"
                })
            }
        }
        if (val === "ok") {


            if(this.state.x !== 0 && this.state.y !== 0){
                this.props.setCustomizedSize(this.state.x,this.state.y, "ok");
                if (a === "notSelected") {
                    InitialQuotationState.conformBtn = false;
                }
                if (this.state.x === 0 || this.state.y === 0) {
                    InitialQuotationState.conformBtn = false;
                }
                a = "notSelected";
            }

            else {
                this.setState({
                    y: 0,
                    x: 0,
                    error : "カスタムサイズを入力して下さい。"
                })
            }


        }

    };
    validateDimension = (val) => {
        const pattern = /^[0-9\b.]+$/;
        if (val.match(pattern)) {
            return true;
        } else {
            return false;
        }
    };

    validateDimensionX = (val) => {
        let dimension = this.props.quotation.smtStencilParam.dimensionsID;
        let sizeX;
        if(this.props.quotation.smtStencilParam.framework===0){
            sizeX = dimension === 112 ? "290" :
                dimension === 501 ?  "400":
                    dimension === 502 ? "420" :
                        dimension === 503 ? "490" :
                            dimension === 504 ? "430" : '';

        } else {

            sizeX = dimension === 112 ? "290" :
                dimension === 111 ? "240" :
                    dimension === 3 ? "340" :
                        dimension === 6 ? "370" :
                            dimension === 7 ? "380" :
                                dimension === 5 ? "450" :
                                    dimension === 124 ? "500" :
                                        dimension === 108 ? "400" :
                                            dimension === 8 ? "500" :
                                                    dimension === 109 ? "600" :
                                                        dimension === 119 ? "600" :
                                                            dimension === 110 ? "760" : '';
        }
        const pattern = /^[0-9\b.]+$/;
        if (val.match(pattern)) {
            if(val<=parseInt(sizeX)){
                console.log("true int");
                return true;

            }else {
                console.log("false int");

                return false;
            }

        } else {
            console.log("false int outer");
            return false;
        }
    };

    validateDimensionY = (val) => {
        let dimension = this.props.quotation.smtStencilParam.dimensionsID;
        let sizeY;
        if(this.props.quotation.smtStencilParam.framework===0){
            sizeY = dimension === 112 ? "190" :
                dimension === 501 ?  "240":
                    dimension === 502 ? "270" :
                        dimension === 503 ? "340" :
                            dimension === 504 ? "380" : '';

        } else {

            sizeY = dimension === 112 ? "190" :
                dimension === 111 ? "140" :
                    dimension === 3 ? "240" :
                        dimension === 6 ? "270" :
                            dimension === 7 ? "380" :
                                dimension === 5 ? "350" :
                                    dimension === 124 ? "320" :
                                        dimension === 108 ? "220" :
                                            dimension === 8 ? "500" :
                                                    dimension === 109 ? "220" :
                                                        dimension === 119 ? "320" :
                                                            dimension === 110 ? "220" : '';
        }
        const pattern = /^[0-9\b.]+$/;
        if (val.match(pattern)) {
            if(val<=parseInt(sizeY)){
                return true;
            }else {
                return false;
            }

        } else {
            return false;
        }
    };

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({
            show: true
        });
    };

    selectSize = () => {

    };
    closeModel = () => {
        this.setState({
            show: false
        },()=> {
            this.props.setStencilParams({id : 0, name : "customizeFlag"})
        })
    };

    render() {
        let size;
        let circuitSize;
        let dimension = this.props.quotation.smtStencilParam.dimensionsID;
        if(this.props.quotation.smtStencilParam.framework===0){
            size = dimension === 112 ? "380×280" :
                dimension === 501 ?  "420×320":
                    dimension === 502 ? "450×350" :
                        dimension === 503 ? "520×420" :
                            dimension === 504 ? "460×460" : '';

            circuitSize = dimension === 112 ? "290mm × 190mm" :
                dimension === 501 ?  "400mm × 240mm":
                    dimension === 502 ? "420mm × 270mm" :
                        dimension === 503 ? "490mm × 340mm" :
                            dimension === 504 ? "430mm × 380mm" : '';

        } else {

            size = dimension === 2 ? "470×370" :
                dimension === 111 ?  "400×300":
                    dimension === 3 ? "520×420" :
                        dimension === 6 ? "550×450" :
                            dimension === 7 ? "584×584" :
                                dimension === 5 ? "650×550" :
                                    dimension === 124 ? "700×500" :
                                        dimension === 108 ? "600×400" :
                                            dimension === 8 ? "736×736" :
                                                dimension === 3 ? "520×420" :
                                                    dimension === 109 ? "800×400" :
                                                        dimension === 114 ? "800×500" :
                                                            dimension === 110 ? "1000×400" : '';

            circuitSize = dimension === 2 ? "290mm × 190mm" :
                dimension === 111 ?  "240mm × 140mm":
                    dimension === 3 ? "340mm × 240mm" :
                        dimension === 6 ? "370mm × 270mm" :
                            dimension === 7 ? "380mm × 380mm" :
                                dimension === 5 ? "450mm × 350mm" :
                                    dimension === 124 ? "500mm × 320mm" :
                                        dimension === 108 ? "400mm × 220mm" :
                                            dimension === 8 ? "500mm × 500mm" :
                                                dimension === 3 ? "340mm × 240mm" :
                                                    dimension === 109 ? "600mm × 220mm" :
                                                        dimension === 114 ? "600mm × 320mm" :
                                                            dimension === 110 ? "760mm × 220mm" : '';
        }


        return (
            <span className="customize-size-span" >
            {/*  <a className="btn btn-xs  view-act-btn no-padding " onClick={this.handleShow}>
            <FormattedMessage id="app.print-order.print"
                              defaultMessage="Invoice"
                              description=""/>
            </a>*/}
                <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="stencil-customized-size-modal"
                       className="customize-size-span">
            <Modal.Body closeButton id="size-custom-body">
                <img src={closeBtnModel} alt=""  className="close-btn-model" onClick={() => this.closeModel()}/>
                <div className="row">
                    <div className="col-md-6">
                        <div className="col-md-offset-2">
                            <div className="row text-align-center" id="size1-txt">{circuitSize.substring(0,3)}mm</div>
                            <div className="row">
                                 <div className="col-md-1" id="size2-txt">{circuitSize.substring(8,11)}mm</div>
                            <div className="col-md-11 ">
                                <img src={size1} className="ime2-model-stencil-responsive"/></div>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6 ">
                        <img  className="ime-model-stencil-responsive" src={size2}/>
                    </div>

                </div>
                <div className="spacer"></div>
                <div className="row aa33">
                            <div className="col-md-offset-1 col-md-4 font-size-model-13">

                                    &nbsp;<input
                                type="radio"
                                name="react-tips"
                                value="option1"
                                defaultChecked
                                className="form-check-input"
                                onClick={(event) => this.conformCustomSize(event, 1)}
                            />&nbsp;
                                {/*フルサイズ：420mm x 320mm*/}
                                フルサイズ：{size.substring(0,3)}mm x {size.substring(4,7)}mm
                            </div>
                    <div className="col-md-5 col-md-offset-1">
                        <div className="row font-size-model-13 resp-customized-size-text">
                            &nbsp;&nbsp;
                            有効エリア ({circuitSize}) より大きくできません
                        </div>
                        <div className="row">
                            <br/>
                            <div className="col-md-6 font-size-model-13">
                                <input
                                    type="radio"
                                    name="react-tips"
                                    value="option1"
                                    // checked={true}
                                    onClick={(event) => this.conformCustomSize(event, 2)}

                                    className="form-check-input"
                                />&nbsp;

                                カスタムサイズ：
                            </div>
                            <div className="col-md-1 font-size-model-13 xy-div">
                                <div className="row x-div">
                                x
                                </div>
                                <div className="row">
                                y
                                </div>
                            </div>
                            <div className="col-md-4 font-size-model-13">
                                <div className="row no-padding-right">
                                     <div className="col-md-1 custom-col-1 xy-div-mobi">x</div>
                                    <div className="col-md-7 custom-col-7">
                                        <input id="xValue"
                                               className="form-control input-sm axis-input resp-customized-size-input" placeholder="mm"
                                               disabled={this.state.isDisabled}
                                               onChange={(event) => this.conformCustomSize(event, 3)}/>
                                    </div>
                                    <div className="col-md-2 custom-col-2 custom-mm">
                                        mm
                                    </div>
                                    <div className="col-md-2 custom-col-2"></div>

                                </div>
                                <div className="row no-padding-right">
                                     <div className="col-md-1 custom-col-1 xy-div-mobi">y</div>
                                    <div className="col-md-7 custom-col-7 ">
                                        <input id="yValue"
                                               className="form-control input-sm axis-input resp-customized-size-input" placeholder="mm"
                                               disabled={this.state.isDisabled}
                                               onChange={(event) => this.conformCustomSize(event, 4)}/>
                                    </div>
                                    <div className="col-md-2 custom-col-2 custom-mm">
                                        mm
                                    </div>
                                     <div className="col-md-2 custom-col-2"></div>

                                </div>
                            </div>

                        </div>

                    </div>
                            </div>

                {
                    this.state.error !== null ?
                        <div className="row text-danger error-text-stencil-resp">
                            {this.state.error}
                        </div> : ''
                }

                <div className="row confirm-btn-resp-stencil">
                    <br/>
                    <div className="">
                        <button className="btn size-confirm-btn" name="ok"
                                onMouseOver={()=>{
                                    document.getElementById("text-color-btn-white").classList.add("text-color-btn-green");
                                    document.getElementById("text-color-btn-white").classList.remove("text-color-btn-white")
                                }}
                                onMouseLeave={()=>{
                                    document.getElementById("text-color-btn-white").classList.add("text-color-btn-white");
                                document.getElementById("text-color-btn-white").classList.remove("text-color-btn-green")}}
                                onClick={(event) => {
                                    this.conformCustomSize(event, "ok");
                                    document.getElementById("text-color-btn-white").classList.add("text-color-btn-white");
                                    document.getElementById("text-color-btn-white").classList.remove("text-color-btn-green");
                                }}><text id="text-color-btn-white">変更</text></button>
                    </div>

                </div>

            </Modal.Body>
        </Modal>
        </span>
        )
    }

}

export default StencilCustomizedSize;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilCustomizedSize/StencilCustomizedSize.js